module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAC4SURBVDiNpZNbEcIwEEVvoqASKgEUEBRQKTiohEqoBRyAg9RBLODg8JMOmZ2m4XFm8rV37252E8kA9MAMRN4kYAKC1ZeJXRa1mIBuKzk2EkuiNahVHoBrrZM1OexUCo147yVdqoNpM3pJwx8GBy+pb4ie+VQN9jg55xZJR0mPTQXt9d2BPmtHE0te0tLoIkiKwCipM7Gby+6pYVLjvF7jkydsmb6dRUmk8h9++0zGKGRRMhVn8jZKXklo7GFUZv65AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Buy.png
// module id = tk/o
// module chunks = 1